<template>
	<header id="header" class="header">
		<section class="headline">
			<div class="inner">
				<a
					class="logo"
					href="https://www.pixnet.net/"
					target="_blank"
					rel="noreferrer noopener"
				></a>
			</div>
		</section>
		<section class="kv">
			<div class="inner">
				<div class="bg">
					<div class="left bg-sub">
						<img class="sticker" src="../assets/kv/sticker.png" />
						<img class="text-1" src="../assets/kv/text-1.png" />
						<img class="text-2" src="../assets/kv/text-2.png" />
						<a href="https://bit.ly/3D0Lvq0" class="kv-btn" target="_blank">
							立即申請試用
						</a>
					</div>
					<div class="right bg-sub">
						<img class="search" src="../assets/kv/search.png" />
						<img class="product" src="../assets/kv/product.png" />
					</div>
				</div>
				
			</div>
		</section>
	</header>
</template>

<script>
export default {
	name: "NavbarComponent"
};
</script>